import { priceMatrix } from '../../models/tariff';
/**
 * The priceForTariff function returns a price based on the age, deductible,
 * and the selected tariff.
 *
 * The price is fixed on all tariffs for customers under 16 and 20 years old.
 * Customers cannot be covered if they are older than 70. After this age,
 * the function will return the same price.
 *
 * @param age number the age of the customer
 * @param tariff Tariff any of the valid tariffs of the private health insurance
 * @param deductible DeductibleForTariff the deductible
 */
export var priceForTariff = function (age, tariff, deductible) {
    if (age <= 16) {
        return priceMatrix[0][tariff][deductible];
    }
    if (age <= 20) {
        return priceMatrix[1][tariff][deductible];
    }
    return priceMatrix[Math.min(priceMatrix.length - 1, age - 19)][tariff][deductible];
};
